import { transformPromotion } from '@src/app/promotions/mappers/transformPromotion';
import {
    Promotion,
    PromotionDto,
} from '@app/promotions/types';
import {
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';
import {
    getCmsUrl,
    getCmsLocalePath,
} from '@core/services/cms/utils';
import { defaultHttpTimeoutMs } from '@core/constants';
import { getShellConfig } from '@src/config/shell/config';
import { siteNapoleonDomainMap } from '@utils/types/NapoleonDomain';
import { currentSite } from '@app/utils/domainHelpers';

export default class PromotionsService {
    private restClient: RestClient = createRestClient(
        getCmsUrl({
            path: `/promotions/${getCmsLocalePath()}/`,
        }),
        defaultHttpTimeoutMs,
    );

    public async getPromotions(groupName: string): Promise<Promotion[]> {
        const data: PromotionDto[] = await this.restClient.get(
            groupName,
            {
                // if van hecke is enabled send domain as a query param true and if not don't send any query param
                params: getShellConfig().remoteConfig.areSitesSplitByLicence
                    ? {
                        domain: siteNapoleonDomainMap[currentSite],
                    }
                    : {},
            },
        );
        return data.map(transformPromotion);
    }
}

export const promotionsService = new PromotionsService();
